import { environment } from '@env/environment';

// export const URL_BASE = environment.urlBase;
export const URL_LOGIN = environment.urlLogin;
export const URL_SYSTEM = environment.urlSystem;
export const URL_SCHEDULER = environment.urlScheduler;

export const PATH_KPI = {
  GENERATE_TOKEN: 'generate-token',
  REVOKE_TOKEN: 'revoke-token',
  SYSTEM: {
    DEPARTMENTS_ALL: 'v1/system-department/get-all',
    DEPARTMENTS: 'v1/system-department/get-all-paging',
    DEPARTMENT: 'v1/system-department/get-by-id/',
    UPDATE_DEPARTMENT: 'v1/system-department/update',
    INSERT_DEPARTMENT: 'v1/system-department/insert',
    DELETE_DEPARTMENT: 'v1/system-department/delete/',
    ROLES_ALL: 'v1/system-role/get-all',
    ROLES: 'v1/system-role/get-all-paging',
    ROLE: 'v1//system-role/get-by-id/',
    UPDATE_ROLE: 'v1/system-role/update',
    INSERT_ROLE: 'v1/system-role/insert',
    DELETE_ROLE: 'v1/system-role/delete/',
    USERS: 'v1/system-user/get-all-paging',
    USER: 'v1//system-user/get-by-id/',
    UPDATE_USER: 'v1/system-user/update',
    INSERT_USER: 'v1/system-user/insert',
    DELETE_USER: 'v1/system-user/delete/',
  },
}

export const PATH = {
  GENERATE_TOKEN: 'generate-token',
  REVOKE_TOKEN: 'revoke-token',
  USER_INFO: 'user-info',
  SYSTEM: {
    ROLES: {
      GET_ALL_ROLE: 'v1.0/role/get-all-role',
      CREATE_ROLE: 'v1.0/role/create-role',
      UPDATE_ROLE: 'v1.0/role/update-role',
      DELETE_ROLE: 'v1.0/role/delete-role',
      GET_ROLE_DETAIL: 'v1.0/role/get-role-detail',
      UPLOAD_ROLE: 'v1.0/role/upload-excel'
    },
    RIGHT: {
      GET_ALL_RIGHT: 'v1.0/right/get-all-right',
      GET_RIGHT_DETAIL: 'v1.0/right/get-right-detail',
      UPDATE_RIGHT: 'v1.0/right/update-right',
      CREATE_RIGHT: 'v1.0/right/create-right',
      DELETE_RIGHT: 'v1.0/right/delete-right',
      UPLOAD_RIGHT: 'v1.0/right/upload-excel'
    },
    GROUPS: {
      GET_ALL_GROUP: 'v1.0/group/get-all-group-only',
      CREATE_GROUP: 'v1.0/group/create-group',
      UPDATE_GROUP: 'v1.0/group/update-group',
      UPDATE_GROUP_NEW: 'v1.0/group/update-group-new',
      DELETE_GROUP: 'v1.0/group/delete-group',
      GET_GROUP_DETAIL: 'v1.0/group/get-group-detail',
      DELETE_RELATION_GROUP: 'v1.0/group/delete-relation-group',
    },
    USERS: {
      SEARCH_USER_GROUP: 'v1.0/user/search-user-group',
      GET_ALL_USER: 'v1.0/user/get-all-user',
      GET_ALL_USER_GROUP: 'v1.0/user/get-user-by-group',
      SET_STATUS_USER: 'v1.0/user/set-status-user',
      GET_USER_DETAIL: 'v1.0/user/get-user-detail',
      CREATE_USER: 'v1.0/user/create-user',
      SEARCH_USER: 'v1.0/user/search-user',
      UPDATE_USER: 'v1.0/user/update-user',
      UPLOAD_USERS: 'v1.0/user/upload-excel'
    },
    APP: {
      GET_ALL_APP: 'v1.0/app/get-all-app',
      CREATE_APP: 'v1.0/app/create-app',
      DELETE_APP: 'v1.0/app/delete-app',
      UPDATE_APP: 'v1.0/app/update-app',
      SEARCH_APP: 'v1.0/app/search-app',
      GET_APP_DETAIL: 'v1.0/app/get-app-detail',
      UPLOAD_APP: 'v1.0/app/upload-excel'
    },
    MENU: {
      GET_ALL_MENU: 'v1.0/menu/get-all-menu',
      CREATE_MENU: 'v1.0/menu/create-menu',
      UPDATE_MENU: 'v1.0/menu/update-menu',
      DELETE_MENU: 'v1.0/menu/delete-menu',
      GET_MENU_DETAIL: 'v1.0/menu/get-menu-detail',
      UPLOAD_MENU: 'v1.0/menu/upload-excel'
    },
    REDIS: {
      DELETE_ALL_KEY: 'v1.0/redis/delete-all-key',
      DELETE_KEY: 'v1.0/redis/delete-key',
      GET_ALL_KEY: 'v1.0/redis/get-all-key',
      SEARCH_KEY: 'v1.0/redis/search-key',
      GET_KEY_INFO: 'v1.0/redis/get-key-info',
      GET_LIST_CUSTOMER: 'v1.0/redis/get-customer-info',
      GET_LIST_CATALOG: 'v1.0/redis/get-catalog-key',
      DELETE_ALL_CUSTOMER: 'v1.0/redis/delete-customer-key',
      DELETE_ALL_CATALOG: 'v1.0/redis/delete-catalog-key',
      ADD_CUSTOMER_KEY: 'v1.0/redis/add-customer-key',
      DELETE_CUSTOMER_KEY: 'v1.0/redis/delete-customer'
    },
    MONITOR: {
      GET_ACTION_LOG: 'v1.0/system/get-action-log'
    },
    SCHEDULER: {
      GET_ALL_JOB: 'v1.0/scheduler/get-all-job',
      GET_ALL_JOB_EXECUTED: 'v1.0/scheduler/get-all-job-executed',
      REGISTER_JOB: 'v1.0/scheduler/register-job',
      UPDATE_JOB: 'v1.0/scheduler/update-job',
      PAUSE_JOB: 'v1.0/scheduler/pause-job',
      RESUME_JOB: 'v1.0/scheduler/resume-job',
      UNSCHEDULE_JOB: 'v1.0/scheduler/unschedule-job',
      DELETE_JOB: 'v1.0/scheduler/delete-job',
      START_JOB_NOW: 'v1.0/scheduler/start-job-now',
      GET_JOB_DETAIL: 'v1.0/scheduler/get-job-detail'
    },
    SEARCH_SITE: 'v1.0/site/search-site',
    GET_ALL_SITE: 'v1.0/site/get-all-site',
    GET_SITE_DETAIL: 'v1.0/site/get-site-detail',
    GET_ALL_SITE_CHOOSING: 'v1.0/site/get-all-site-choosing'
  },
}

export const MenyType = {
  SYSTEM: 'SYSTEM',
  SERVICE: 'SERVICE',
  FUNCTION: 'FUNCTION'
}

export const LOCK = 'LOCK';
export const UNLOCK = 'UNLOCK';

export const URL_GET_ALL = [
  { key: 'GET_ALL_SITE', value: 'listSite', url: URL_SYSTEM },
];

// tslint:disable-next-line:variable-name
export const Status = {
  SUCCESS: 0,
  EXIST: 107,
  ERROR: 500,
};

export const VERTICAL = 'vertical';
export const HORIZONTAL = 'horizontal';

export const DFORM_MENU = 'dform_menu';
export const EMB_MENU = 'emb_menu';
export const DFORM = 'setting';
export const EMB = 'emb';
export const NODE_BASE = 0;
export const NODE_PARENT = 1;
export const NODE_CHILD = 2;

export const MAKER = 'MAKER'; // Role nhập liệu
export const APPROVER = 'APPROVER'; // Role duyệt

// các dạng lấy danh sách dữ liệu trong bảng eblookup
export const TYPE_EBLOOKUP = {
  monthlyIncome: 'NET.MONTHLY.IN',
  workingStatus: 'EMPLOYMENT.STATUS',
  buss: 'EMPLOYERS.BUSS',
  poisition: 'POSITION'
};

export const categoryID1003 = '1003';

export const URL_CLIENT_CATALOG = `/system`;
export const URL_CLIENT_SITE = `site/get-all-site`;
export const URL_CLIENT_TOKEN = `generate-token`;
export const URL_APPROVEALL = `/approve`;
export const URL_SENDAPPROVEALL = `process/send-approve`;
export const URL_CLIENT_REVOKE_TOKEN = `revoke-token`;
export const URL_CLIENT_SEARCH_CUSTOMER = `customer/search-customer`;
export const URL_INIT_PROCESS = `process/init-process`;
export const URL_GET_GENERAL = `/customer/general-information`;
export const URL_REPORT = `v1.0/form`;
export const URL_GET_LD_LIST = 'customer/get-ldlist';
export const URL_GET_AVATAR = 'customer/get-avatar';
export const URL_GET_SIGNATURE_IMAGE = 'customer/get-signature-image';
export const URL_GET_POINTMENT_LOYALTY = 'customer/get-pointment-loyalty';
export const URL_GET_BY_CUSTOMER = 'get-by-customer-code';

/**
 * Tổng hợp url kiểm tra bỏ qua timeout
 */
export const URL_TIMEOUT = [
  // URL_APPROVEALL,
  // URL_SENDAPPROVEALL,
  // URL_INIT_PROCESS,
  // URL_CLIENT_TOKEN,
  // URL_CLIENT_REVOKE_TOKEN,
  // URL_GET_GENERAL,
  // URL_CLIENT_SEARCH_CUSTOMER,
  // URL_GET_LD_LIST,
  // URL_GET_AVATAR,
  // URL_GET_SIGNATURE_IMAGE,
  // URL_GET_POINTMENT_LOYALTY,
  // URL_GET_BY_CUSTOMER
]

/**
 * Tổng hợp url kiểm tra bỏ qua show message error
 */
export const URL_ERROR = [
  // URL_CLIENT_CATALOG,
  // URL_APPROVEALL,
  // URL_CLIENT_SITE,
  // URL_CLIENT_TOKEN,
  // URL_CLIENT_SEARCH_CUSTOMER,
  // URL_REPORT,
  // URL_CLIENT_REVOKE_TOKEN,
  // URL_GET_LD_LIST,
  // URL_GET_AVATAR,
  // URL_GET_SIGNATURE_IMAGE,
  // URL_GET_POINTMENT_LOYALTY
];

export const MENU_KEY = {
  GENERAL: 'general',
  INFO_APPROVE: 'info-approve',
  SMS: 'sms',
  ACCOUNT: 'account',
  CARD: 'card',
  EBANKING: 'ebanking',
  CUSTOMER: 'customer',
  PACKAGE: 'package',
  REPORT: 'report'
};

export const SUB_PRODUCT_BEAUTY = '719';

export const eventCreate = "C";
export const eventEdit = "E"
export const eventDelete = "D"
export const eventCreateParent = "CP"
export const eventReload = "R"

export const _method = [
  { key: '200', value: '200' },
  { key: '226', value: '226' },
  { key: '302', value: '302' },
  { key: '400', value: '400' },
  { key: '401', value: '401' },
  { key: '403', value: '403' },
  { key: '404', value: '404' },
  { key: '405', value: '405' },
  { key: '417', value: '417' },
  { key: '422', value: '422' },
  { key: '500', value: '500' },
]

export const MENU_TYPE_LINK = [
  {
    key: 'extLink',
    value: 'ExtLink'
  },
  {
    key: 'extTabLink',
    value: 'ExtTabLink'
  },
  {
    key: 'angularLink',
    value: 'AngularLink'
  },
  {
    key: 'postDataLink',
    value: 'PostDataLink'
  },
]

export const LockType = {
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
  WAIT_APPROVE: 'WAIT_APPROVE',
  DENY: 'DENY'
}

